import { cn } from '@mc/educator-design-system'

export interface StatCardItem {
  id: string | number
  label: string
  value: string
}

export interface StatCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  stats: StatCardItem[]
}

export const StatCard = ({
  title,
  stats,
  className,
  ...rest
}: StatCardProps) => (
  <div className={cn('p-4 w-full', className)} {...rest}>
    <div className='pb-[70px] flex items-start'>
      <h2 className='text-body-1 font-semibold leading-[1.4] font-sans text-white'>
        {title}
      </h2>
    </div>
    <div className='flex flex-col w-full'>
      {stats.map((stat) => (
        <div
          key={stat.id}
          className='border-t border-white/25 flex flex-col gap-2 py-4 w-full'
        >
          <p className='text-body-2 font-semibold leading-[1.4] font-sans text-white'>
            {stat.label}
          </p>
          <p className='text-[48px] font-normal leading-[48px] font-serif text-white pb-5'>
            {stat.value}
          </p>
        </div>
      ))}
    </div>
  </div>
)
